/* import __COLOCATED_TEMPLATE__ from './custom-score.hbs'; */
/* RESPONSIBLE TEAM: team-fin-qa */
import Component from '@glimmer/component';
import type ConversationTableEntry from 'embercom/objects/inbox/conversation-table-entry';

interface Signature {
  Args: {
    conversationEntry: ConversationTableEntry;
  };
  Element: HTMLSpanElement;
}

export default class CustomScore extends Component<Signature> {
  get passed(): boolean | undefined {
    return this.args.conversationEntry.customScorePassed;
  }

  get hasPassed(): boolean {
    return this.passed === true;
  }

  get hasFailed(): boolean {
    return this.passed === false;
  }

  get isCriticalFailure(): boolean {
    return this.hasFailed && this.args.conversationEntry.customScoreCriticalFailure === true;
  }

  get scoreDisplay(): string | undefined {
    let score = this.args.conversationEntry.customScoreValue;
    if (score === undefined) {
      return undefined;
    }
    return `${score}%`;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationsTable::TableCells::CustomScore': typeof CustomScore;
    'inbox2/conversations-table/table-cells/custom-score': typeof CustomScore;
  }
}
